// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class ResellerResource extends Resource {
    basePath: string = 'services/reseller/';

    objectPath: string = 'services/reseller/{ident}/';
}
